import { FC } from 'react';
import CommonHeader from '../CommonHeader';

interface ITicketBookingHeaderProps{}

const TicketBookingHeader: FC<ITicketBookingHeaderProps> = ()=>{
  return  <CommonHeader/>;
}

export default TicketBookingHeader;